import styled from 'styled-components';

export const SafeAnchorOffset = styled.div`
  display: block;
  position: relative;
  visibility: hidden;
  top: ${({ offsetTop }) => offsetTop};
`;
